// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dQG5Ok9dgvOTAscPSi3R {
  width: 100%;
}
.qsDTZ5j1MhNNw9kCcZAN {
  position: absolute;
  right: -12px;
  top: -12px;
  border: 1px solid red;
  border-radius: 50%;
  color: red;
  width: 24px;
  height: 24px;
  text-align: center;
  display: none;
  background-color: #fff;
  line-height: 24px;
}
.mZ1wr5lGEGwnA61zXCon {
  flex: 1;
  min-width: 100px;
  max-width: 300px;
  height: 32px;
  align-items: center;
  position: relative;
}
.mZ1wr5lGEGwnA61zXCon:hover {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding-right: 5px;
}
.CLmm3mvBhHnDKpIH_GYO {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: flex-end;
}
.H7m5FmwI7DRW0Ff7ieUP {
  justify-content: flex-start;
}
.Lh6l1ErQrfR6v85tZOqz {
  justify-content: center;
}
.tpqS0MGpoMvgxRu2vGD5 {
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/DivInput/styles.module.less"],"names":[],"mappings":"AACA;EACE,WAAA;AAAF;AAGA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AADF;AAIA;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAFF;AAKA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAMA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;AAJF;AAOA;EACE,2BAAA;AALF;AAQA;EACE,uBAAA;AANF;AASA;EACE,yBAAA;AAPF","sourcesContent":["\n.editor {\n  width: 100%;\n}\n\n.removeIcon {\n  position: absolute;\n  right: -12px;\n  top: -12px;\n  border: 1px solid red;\n  border-radius: 50%;\n  color: red;\n  width: 24px;\n  height: 24px;\n  text-align: center;\n  display: none;\n  background-color: #fff;\n  line-height: 24px;\n}\n\n.container {\n  flex: 1;\n  min-width: 100px;\n  max-width: 300px;\n  height: 32px;\n  align-items: center;\n  position: relative;\n}\n\n.container:hover {\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding-right: 5px;\n}\n\n.valueWarp {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  justify-content: flex-end;\n}\n\n.alignLeft {\n  justify-content: flex-start;\n}\n\n.alignCenter {\n  justify-content: center;\n}\n\n.alignRight {\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `dQG5Ok9dgvOTAscPSi3R`,
	"removeIcon": `qsDTZ5j1MhNNw9kCcZAN`,
	"container": `mZ1wr5lGEGwnA61zXCon`,
	"valueWarp": `CLmm3mvBhHnDKpIH_GYO`,
	"alignLeft": `H7m5FmwI7DRW0Ff7ieUP`,
	"alignCenter": `Lh6l1ErQrfR6v85tZOqz`,
	"alignRight": `tpqS0MGpoMvgxRu2vGD5`
};
export default ___CSS_LOADER_EXPORT___;
